import FloorPlanDetail from '../components/FloorPlanDetail';

export default function FloorPlan21GardenPage() {
  const floorPlanData = {
    id: '2-1-garden',
    title: '2+1 Bahçe Katı',
    totalArea: '110 m²',
    rooms: '2 Yatak Odası + 1 Salon + Bahçe',
    image: '/plan-2-1-garden.png',
    description: 'Bahçe katı dairemiz, müstakil ev konforunu apartman güvenliğiyle birleştiriyor. Doğrudan salondan çıkış yapılabilen geniş özel bahçe alanı ile doğayla iç içe bir yaşam sunar. Özellikle evcil hayvan besleyenler ve bahçe keyfi yapmak isteyen küçük aileler için idealdir.',
    roomDetails: [
      { name: 'Salon', dimensions: '4.50 x 6.20 m', area: '27.90 m²' },
      { name: 'Mutfak', dimensions: '3.00 x 3.80 m', area: '11.40 m²' },
      { name: 'Ana Yatak Odası', dimensions: '3.60 x 4.40 m', area: '15.84 m²' },
      { name: 'Yatak Odası', dimensions: '3.20 x 3.80 m', area: '12.16 m²' },
      { name: 'Banyo', dimensions: '2.40 x 3.00 m', area: '7.20 m²' },
      { name: 'Özel Bahçe Terası', dimensions: '5.50 x 8.00 m', area: '44.00 m²' },
      { name: 'Koridor & Hol', dimensions: '-', area: '11.50 m²' }
    ],
    features: [
      'Geniş müstakil bahçe kullanımı',
      'Bahçeye doğrudan erişim',
      'Yüksek tavan ferahlığı',
      'Modern peyzajlı bahçe alanı',
      'Güvenlikli giriş',
      'Yerden ısıtma sistemi',
      'Isı yalıtımlı zemin',
      'Özel aydınlatmalı bahçe terası'
    ]
  };

  return <FloorPlanDetail data={floorPlanData} />;
}
